import { NgModule } from '@angular/core';

import { MyDecimalPipe } from './decimal/my-decimal.pipe';
import { MyCurrencyPipe } from './currency/my-currency.pipe';
import { MyPercentPipe } from './percent/my-percent.pipe';

@NgModule({
    declarations: [MyDecimalPipe, MyCurrencyPipe, MyPercentPipe],
    imports: [],
    exports: [MyDecimalPipe, MyCurrencyPipe, MyPercentPipe],
})
export class PipesModule {}
